module.exports = __webpack_public_path__ + "media/images/icons/filled/mobile-1af1a63befb8ce83b9c3ee97a64b8cbd.svg";